<script setup>
const props = defineProps({
  mapCenter: { type: Array, required: true },
  mapZoom: { type: Number, required: true },
  tmpMarkerPosition: { type: Object, required: true }
})
const route = useRoute()
const config = useRuntimeConfig()
const isOverlayOpen = defineModel('isOverlayOpen', { type: Boolean })
const position = useCookie('mapView')
const markerPosition = useCookie('markerPosition', { default: () => null })
const { data: buttonList } = await useFetch('/api/radar/buttonList')

const onClickButton = (weather) => {
  if (weather === 'wind') {
    isOverlayOpen.value = false
    return
  } else {
    position.value = { lat: props.mapCenter[1], lon: props.mapCenter[0], zoom: props.mapZoom }
    if (Object.keys(props.tmpMarkerPosition).length > 0) {
      markerPosition.value = props.tmpMarkerPosition
    }
    const path = createRadarLink(weather, route.path)
    return navigateTo(`${config.public.hostDomain}${path}`, { external: true })
  }
}
</script>

<template>
  <MiOOverlay
    :data-showed="isOverlayOpen"
    @click.self="isOverlayOpen = false"
  >
    <MiMOverlayBlock
      data-position="right"
      data-style="border"
    >
      <template
        v-for="({ category, label }) in buttonList"
        :key="category"
      >
        <MiARadarButton>
          <WindRadarLinkButton
            :category="category"
            :label="label"
            @click="onClickButton(category)"
          />
        </MiARadarButton>
      </template>
      <MiACloseButton data-type="circle">
        <button @click="isOverlayOpen = false" />
      </MiACloseButton>
    </MiMOverlayBlock>
  </MiOOverlay>
</template>

<style lang="scss" scoped>
</style>
